import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { FirmwareService } from '@devices';
import { Firmware } from '@devices/models/firmware';
import { MessageComponent, NotificationsService } from '@ui';
import { finalize } from 'rxjs';

type ConfirmUpdateFirmwareDialogProps = {
  currentVersion: string;
  deviceId: string;
  firmware: Partial<Firmware>;
};

@Component({
  imports: [CommonModule, MatDialogModule, MessageComponent, MatIcon],
  selector: 'avs-update-firmware-dialog',
  standalone: true,
  templateUrl: './update-firmware-dialog.component.html',
})
export class UpdateFirmwareDialogComponent {
  protected dialogRef = inject(MatDialogRef<UpdateFirmwareDialogComponent>);
  protected data = inject<ConfirmUpdateFirmwareDialogProps>(MAT_DIALOG_DATA);
  protected isFirmwareUpdating = signal(false);
  private notificationService = inject(NotificationsService);
  private firmwareService = inject(FirmwareService);

  protected confirm() {
    this.isFirmwareUpdating.set(true);

    this.firmwareService.updateDevice(this.data.firmware.id!, this.data.deviceId)
      .pipe(
        finalize(() => {
          this.isFirmwareUpdating.set(false);
        }),
      )
      .subscribe({
        error: error => {
          this.notificationService.showErrorMessage(error.message);
        },
        next: () => {
          this.notificationService.showSuccessMessage('Request to update firmware was successfully sent');
          this.dialogRef.close(true);
        },
      });
  }
}
